<template>
  <div>
    <HFooter></HFooter>
  </div>
</template>

<script>
import HFooter from 'vue-hacktiv8-footer'

export default {
  components: {
    HFooter
  }
}
</script>

<style>

</style>